import React from 'react';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import FilterListIcon from '@mui/icons-material/FilterList';
import {Box, IconButton} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {DefectFilter} from '@app/model';

interface FilterIconButtonProps {
	filter: DefectFilter;
	setFilter: React.Dispatch<React.SetStateAction<DefectFilter>>;
	fetchAllRooms: () => void;
}

export function DefectsFilterIconButton(props: FilterIconButtonProps) {
	const {filter, setFilter, fetchAllRooms} = props;
	const {t} = useTranslation('section');

	function isFilterSet(): boolean {
		return !!filter && Object.values(filter).filter((filterItem) => !!filterItem).length > 0;
	}

	function renderFilterIcon() {
		return isFilterSet() ? (
			<FilterListOffIcon fontSize="medium" />
		) : (
			<FilterListIcon fontSize="medium" />
		);
	}

	function handleFilterReset() {
		setFilter({});
		fetchAllRooms();
	}

	return (
		<Box title={isFilterSet() ? t('filters.removeAllFilters') : t('filters.filter')}>
			<IconButton size="small" disabled={!isFilterSet()} onClick={() => handleFilterReset()}>
				{renderFilterIcon()}
			</IconButton>
		</Box>
	);
}
